export const getCallsCampaignTitleBasedOnCategory = (
    categorySlug: string | undefined,
) => {
    switch (categorySlug) {
        case "water-damage":
            return "Urgent Water Damage Repair";
        default:
            return "";
    }
};
